import { render } from "./login_user.vue?vue&type=template&id=18775016&scoped=true&ts=true"
import script from "./login_user.vue?vue&type=script&lang=ts"
export * from "./login_user.vue?vue&type=script&lang=ts"

import "@/style/common.less?vue&type=style&index=0&id=18775016&scoped=true&lang=less&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18775016"]])

export default __exports__